"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleErrors = exports.handleServiceValidationError = exports.handleGeneralServiceError = exports.handleValidationError = exports.handlePasswordReuseError = void 0;
const ValidationUtils_1 = require("./ValidationUtils");
const ValidationError_1 = __importDefault(require("./errors/ValidationError"));
const GeneralServiceError_1 = __importDefault(require("./errors/GeneralServiceError"));
/**
 *
 * Handles password resuse error
 *
 * @param {AxiosResponse} https://github.com/axios/axios/blob/master/index.d.ts#L70-L77
 * @return void
 *
 */
function handlePasswordReuseError(ex) {
    const response = ex.response || {};
    const responseData = response.data || {};
    const errorCode = responseData.errorCode;
    const errorMessage = responseData.errorMessage;
    if (ValidationUtils_1.isPasswordReuseError(errorCode)) {
        throw new ValidationError_1.default(errorMessage, 'password', errorCode);
    }
}
exports.handlePasswordReuseError = handlePasswordReuseError;
/**
 *
 * Handles validation related errors
 *
 * @param {AxiosResponse} https://github.com/axios/axios/blob/master/index.d.ts#L70-L77
 * @return void
 *
 */
function handleValidationError(ex) {
    const response = ex.response || {};
    const responseData = response.data || {};
    const errorCode = responseData.errorCode;
    const validationFailures = responseData.validationFailures || {};
    // Account service only returns the first validated field
    const targetFieldName = Object.keys(validationFailures)[0] || '';
    const targetValidationObj = validationFailures[targetFieldName];
    if (targetValidationObj && ValidationUtils_1.isValidationError(errorCode)) {
        throw new ValidationError_1.default(targetValidationObj.errorMessage, targetValidationObj.fieldName, targetValidationObj.errorCode);
    }
}
exports.handleValidationError = handleValidationError;
/**
 *
 * Handles any general service errors
 *
 */
function handleGeneralServiceError(ex) {
    const response = ex.response || {};
    const responseData = response.data || {};
    const errorCode = responseData.errorCode;
    const errorMessage = responseData.errorMessage;
    if (errorCode && errorMessage) {
        throw new GeneralServiceError_1.default(errorMessage, errorCode);
    }
}
exports.handleGeneralServiceError = handleGeneralServiceError;
/**
 *
 * Handles general validation errors
 *
 * @param {AxiosResponse} https://github.com/axios/axios/blob/master/index.d.ts#L70-L77
 * @return void
 *
 */
function handleServiceValidationError(ex) {
    // Password related validation
    handlePasswordReuseError(ex);
    // Handle general validation
    handleValidationError(ex);
}
exports.handleServiceValidationError = handleServiceValidationError;
/**
 *
 * General Service error handler
 *
 * @param {AxiosResponse} https://github.com/axios/axios/blob/master/index.d.ts#L70-L77
 * @param {String}        Custom log message
 * @return void
 *
 */
function handleErrors(ex, customMessage) {
    handleServiceValidationError(ex);
    handleGeneralServiceError(ex);
    console.error(`${customMessage}`, ex.message);
    throw ex;
}
exports.handleErrors = handleErrors;
//# sourceMappingURL=ErrorUtils.js.map